import React, { useState } from "react";
import { Link } from "react-router-dom";
import CreateListingForm from "./listing/CreateListingForm";

function HoatDong() {
  const [activeTab, setActiveTab] = useState("activities");

  return (
    <div className="hoat-dong-page">
      <div className="page-header">
        <h1>Hoạt động</h1>
        <p>Quản lý hoạt động mua bán và đăng tin của bạn</p>
      </div>
      
      <div className="content-section">
        <div className="container">
          {/* Tab Navigation */}
          <div className="tab-navigation">
            <button 
              className={`tab-btn ${activeTab === "activities" ? "active" : ""}`}
              onClick={() => setActiveTab("activities")}
            >
              Hoạt động của tôi
            </button>
            <button 
              className={`tab-btn ${activeTab === "create" ? "active" : ""}`}
              onClick={() => setActiveTab("create")}
            >
              Đăng tin sản phẩm
            </button>
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === "activities" && (
              <div className="activities-section">
                <h2>Hoạt động gần đây</h2>
                <div className="activities-grid">
                  <div className="activity-card">
                    <div className="activity-icon">📝</div>
                    <div className="activity-info">
                      <h3>Tin đăng của bạn</h3>
                      <p>Xem và quản lý các sản phẩm bạn đã đăng</p>
                      <Link to="/market/my-listings" className="activity-link">Xem chi tiết →</Link>
                    </div>
                  </div>
                  
                  <div className="activity-card">
                    <div className="activity-icon">🛒</div>
                    <div className="activity-info">
                      <h3>Đã mua</h3>
                      <p>Lịch sử các sản phẩm bạn đã mua</p>
                      <Link to="/market/purchases" className="activity-link">Xem chi tiết →</Link>
                    </div>
                  </div>
                  
                  <div className="activity-card">
                    <div className="activity-icon">💬</div>
                    <div className="activity-info">
                      <h3>Tin nhắn</h3>
                      <p>Tin nhắn từ người mua và bán</p>
                      <Link to="/market/messages" className="activity-link">Xem chi tiết →</Link>
                    </div>
                  </div>
                  
                  <div className="activity-card">
                    <div className="activity-icon">⭐</div>
                    <div className="activity-info">
                      <h3>Đánh giá</h3>
                      <p>Đánh giá và phản hồi từ khách hàng</p>
                      <Link to="/market/reviews" className="activity-link">Xem chi tiết →</Link>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "create" && (
              <div className="create-section">
                <h2>Đăng tin sản phẩm mới</h2>
                <CreateListingForm />
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .hoat-dong-page {
          min-height: 100vh;
          background-color: #0f172a;
          color: #e5e7eb;
          padding: 40px 0;
        }
        
        .page-header {
          text-align: center;
          padding: 40px 20px;
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
        }
        
        .page-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #f1f5f9;
        }
        
        .page-header p {
          font-size: 1.125rem;
          color: #cbd5e1;
        }
        
        .content-section {
          padding: 40px 20px;
        }
        
        .container {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .tab-navigation {
          display: flex;
          gap: 1rem;
          margin-bottom: 2rem;
          border-bottom: 1px solid #334155;
        }
        
        .tab-btn {
          background: transparent;
          color: #cbd5e1;
          border: none;
          padding: 12px 24px;
          cursor: pointer;
          font-size: 1rem;
          font-weight: 500;
          border-bottom: 2px solid transparent;
          transition: all 0.2s;
        }
        
        .tab-btn:hover {
          color: #f1f5f9;
        }
        
        .tab-btn.active {
          color: #4ade80;
          border-bottom-color: #4ade80;
        }
        
        .tab-content {
          margin-top: 2rem;
        }
        
        .activities-section h2 {
          font-size: 1.875rem;
          margin-bottom: 2rem;
          color: #f1f5f9;
        }
        
        .activities-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 1.5rem;
        }
        
        .activity-card {
          background-color: #1e293b;
          padding: 2rem;
          border-radius: 12px;
          border: 1px solid #334155;
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          transition: all 0.2s;
        }
        
        .activity-card:hover {
          border-color: #4ade80;
          transform: translateY(-2px);
        }
        
        .activity-icon {
          font-size: 2rem;
          flex-shrink: 0;
        }
        
        .activity-info h3 {
          font-size: 1.25rem;
          margin-bottom: 0.5rem;
          color: #f1f5f9;
        }
        
        .activity-info p {
          color: #cbd5e1;
          margin-bottom: 1rem;
          line-height: 1.5;
        }
        
        .activity-link {
          color: #4ade80;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s;
        }
        
        .activity-link:hover {
          color: #36b868;
        }
        
        .create-section h2 {
          font-size: 1.875rem;
          margin-bottom: 2rem;
          color: #f1f5f9;
        }
        
        @media (max-width: 768px) {
          .page-header h1 {
            font-size: 2rem;
          }
          
          .activities-grid {
            grid-template-columns: 1fr;
          }
          
          .activity-card {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
}

export default HoatDong;
